import { render, staticRenderFns } from "./simpletableBlockEditor.vue?vue&type=template&id=05f657a7"
import script from "./simpletableBlockEditor.vue?vue&type=script&lang=js"
export * from "./simpletableBlockEditor.vue?vue&type=script&lang=js"
import style0 from "./simpletableBlockEditor.vue?vue&type=style&index=0&id=05f657a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports